export default function ExhibitorTerms() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="exhibitor-terms-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">Policies</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Exhibitor Terms and Conditions</h1>
      <p className="text-gray-700 leading-relaxed mb-10">
        The following terms apply to every online exhibitor listed on CityShor Pop-Up Bazaar. Registration on the platform implies acceptance of these terms.
      </p>

      <div className="space-y-4">
        <Section title="1. Product Standards">
          <ul className="list-disc pl-5 space-y-1">
            <li>Upload only high-resolution (HD) product images (minimum 1000 x 1000, recommended 1200 x 1200).</li>
            <li>Deliver the exact product shown in the listing. Colour, size, pattern and material must match.</li>
            <li>Product quality must match the description. Misleading listings will be removed.</li>
          </ul>
        </Section>
        <Section title="2. Returns and Exchanges">
          <ul className="list-disc pl-5 space-y-1">
            <li>Accept genuine return requests as per the CityShor Return, Refund and Cancellation Policy.</li>
            <li>Accept product exchanges where applicable.</li>
            <li>Return shipping for reasons other than seller error is borne by the customer.</li>
          </ul>
        </Section>
        <Section title="3. Order Fulfilment">
          <ul className="list-disc pl-5 space-y-1">
            <li>Once notified of a sale, the exhibitor must ship the sold product directly to the customer within 24 hours via the Shiprocket shipment auto-created after order confirmation.</li>
            <li>Shipping charges are handled by CityShor's Shiprocket integration and reconciled on the weekly payout.</li>
            <li>Failure to confirm the order within 2 hours or ship within 24 hours may result in order cancellation and a chargeback.</li>
          </ul>
        </Section>
        <Section title="4. Compliance">
          <ul className="list-disc pl-5 space-y-1">
            <li>Maintain accurate stock availability at all times.</li>
            <li>Deliver products within the committed timeline.</li>
            <li>Any fraudulent activity, counterfeit products, misleading information, repeated customer complaints, or policy violations may result in immediate removal from the platform without prior notice.</li>
            <li>CityShor reserves the right to suspend or permanently remove any exhibitor at its sole discretion for policy violations.</li>
          </ul>
        </Section>
        <Section title="5. Commission and Weekly Settlement">
          <ul className="list-disc pl-5 space-y-1">
            <li>A flat 10 percent commission is deducted from the selling price of every product sold.</li>
            <li>Exhibitors are settled weekly, only for orders that have been delivered and are past the return window.</li>
            <li>Settlement is made to the bank account provided during KYC verification.</li>
          </ul>
        </Section>
        <Section title="6. Vendor Code">
          <p>Every exhibitor receives a unique Vendor Code on registration. All orders, weekly sales reports, returns, replacements and payouts are tracked against this Vendor Code. The code is visible on the exhibitor dashboard and on every internal report.</p>
        </Section>
        <Section title="7. Applicable Law">
          <p>These terms are governed by the laws of India. Any dispute shall be subject to the jurisdiction of the courts of Ahmedabad, Gujarat.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="p-6 bg-white rounded-2xl border border-gray-200">
      <h2 className="font-display text-2xl mb-2">{title}</h2>
      <div className="text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
